import { createContext } from 'react';

const billsContext = createContext();

export default billsContext;